import { render } from "./postitem.vue?vue&type=template&id=03296d9a"
import script from "./postitem.vue?vue&type=script&lang=js"
export * from "./postitem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__